import { useCampaignVisual } from "@app/home/hooks/use-campaign-visual.hook";
import type { SocialHomeBanner } from "@core/home/types";
import { trans } from "@mongez/localization";
import { Link } from "@remix-run/react";
import { ArrowUpLeft } from "lucide-react";

export function CampaignVisual({ banner }: { banner: SocialHomeBanner }) {
  const { actionUrl, opensInNewTab } = useCampaignVisual(banner);

  const content = (
    <div
      className={`group relative w-full overflow-hidden rounded-[1.75rem] bg-gradient-to-br from-violet-700 via-primary-600 to-cyan-500 ${
        banner.image?.url ? "" : "min-h-[clamp(13rem,30vw,28rem)]"
      }`}>
      {banner.image?.url && (
        <img
          src={banner.image.url}
          alt={banner.title || ""}
          className="block h-auto w-full transition duration-700 group-hover:scale-105"
          onError={event => {
            event.currentTarget.style.display = "none";
          }}
        />
      )}
      <div className="absolute inset-x-0 bottom-0 p-6 text-white sm:p-8">
        {banner.title && (
          <h2 className="text-2xl font-black sm:text-3xl">{banner.title}</h2>
        )}
        {banner.description && (
          <p className="mt-2 line-clamp-2 max-w-2xl text-sm text-white/80 sm:text-base">
            {banner.description}
          </p>
        )}
        {actionUrl && (
          <span className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-black text-slate-950">
            {banner.actionLabel || trans("socialHome.exploreNow")}
            <ArrowUpLeft className="h-4 w-4" />
          </span>
        )}
      </div>
    </div>
  );

  if (!actionUrl) return content;

  return opensInNewTab ? (
    <a href={actionUrl} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  ) : (
    <Link to={actionUrl}>{content}</Link>
  );
}
